export default __webpack_public_path__ + "static/img-m-mesquita-1-3783d15650d02e2abbd833f9268e1f79.png";